<template>
    <transition name="fade">
        <div>
            <transition name="fade">
                <video v-show="videoState" loop muted id="motion-window" src="https://player.vimeo.com/external/294103998.hd.mp4?s=176c8ba235698015b63fe00ac2ebf51658f201e5&profile_id=175" autoplay></video>
            </transition>
            <div id="tablet-interaction-show-popup" @click="popUp" @mouseover="videoState = true" @mouseout="popUpMouseOut"></div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'MotionWindow',
        data() {
            return {
                videoState: false,
                popUpState: false
            }
        },
        methods: {
            popUp() {
                if (this.popUpState === false) {
                    $('#motion-window').css({'bottom': '6%', 'right': '21%', 'width': '57%'})
                } else {
                    $('#motion-window').css({'bottom': '5%', 'right': '10%', 'width': '17%'})

                }
                this.popUpState = !this.popUpState
            },
            popUpMouseOut() {
                this.videoState = this.popUpState !== false;
            }
        }
    }
</script>
<style scoped lang="scss">

    #motion-window {
        position: absolute;
        bottom: 5%;
        right: 10%;
        width: 17%;
        border: 5px solid rgba(0, 0, 0, 0.3);
        border-radius: 25%;
        transition: 0.2s;
        z-index: 1;
    }

    #tablet-interaction-show-popup {
        position: absolute;
        width: 11%;
        height: 11%;
        bottom: 8%;
        right: 13%;
        cursor: pointer;
        background-color: transparent;
        transform: skew(60deg, -15deg);
        z-index: 2;
    }

</style>